import { ShieldCheck, Plane, Dna, Video, HandHeart } from "lucide-react";
import { Reveal, SectionHead, Wrap } from "./Motion";

const pillars = [
  { id: "vet", Icon: ShieldCheck, t: "Full Clinical Disclosure", d: "Complete radiographs and independent vetting on every lot, published before bidding." },
  { id: "pedigree", Icon: Dna, t: "Pedigree Integrity", d: "Verified papers, DNA-confirmed parentage and a damline history from the family that bred it." },
  { id: "video", Icon: Video, t: "Tried & Filmed", d: "Every horse ridden and filmed at Ballypatrick under Greg Broderick's eye." },
  { id: "transit", Icon: Plane, t: "White-Glove Transit", d: "Export papers, quarantine and door-to-stable transport coordinated for you." },
  { id: "handover", Icon: HandHeart, t: "Concierge Handover", d: "A direct line to the Ballypatrick team for your first 90 days together." },
];

const Pillar = ({ p, i }) => (
  <div className="h-full bg-[#0F1D3D] p-6 lg:p-9 group hover:bg-[#142447] transition-colors duration-500" data-testid={`ballypatrick-assurance-card-${p.id}`}>
    <div className="flex items-center justify-between">
      <span className="h-10 w-10 flex items-center justify-center border border-[#4B7A38]/50 bg-[#4B7A38]/15 text-[#6FAE55]"><p.Icon size={18} strokeWidth={1.6} /></span>
      <span className="font-mono text-[11px] text-[#6F7C97]">0{i + 1}</span>
    </div>
    <h3 className="mt-6 font-display text-xl lg:text-2xl text-[#F8F6F0]">{p.t}</h3>
    <p className="mt-2 text-sm text-[#AEB7C9] leading-relaxed">{p.d}</p>
  </div>
);

export const Assurance = () => (
  <section id="assurance" className="relative py-20 lg:py-36 bg-[#0F1D3D] overflow-hidden" data-testid="assurance-section">
    <div className="absolute inset-0 spotlight pointer-events-none" />
    <Wrap className="relative">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-12">
        <div className="lg:col-span-5">
          <SectionHead eyebrow="The Ballypatrick Sovereign Assurance" id="assurance"
            title="Buy from Tipperary with the certainty of standing in the arena."
            sub="Five commitments, attached to every lot, written into the terms of sale." />
          <Reveal delay={0.25}>
            <blockquote className="mt-8 lg:mt-12 border-l border-[#D4AF37] pl-5">
              <p className="font-display text-xl sm:text-2xl lg:text-3xl italic text-[#F8F6F0] leading-snug">"She's perfect about everything. She does no wrong."</p>
              <footer className="mt-3 text-[10px] lg:text-xs tracking-[0.18em] uppercase text-[#6F7C97]">Tracey Epp · BP Lady Masterpiece · Lot 3, 2025 · Canada</footer>
            </blockquote>
          </Reveal>
        </div>
        <div className="lg:col-span-7">
          <div className="snap-row lg:hidden -mx-5 px-5" data-testid="assurance-snap-row">
            {pillars.map((p, i) => <div key={p.id} className="w-[78vw] max-w-[320px] border border-[#D4AF37]/20"><Pillar p={p} i={i} /></div>)}
          </div>
          <div className="hidden lg:grid grid-cols-2 gap-px bg-[#D4AF37]/15 border border-[#D4AF37]/15">
            {pillars.map((p, i) => (
              <Reveal key={p.id} delay={i * 0.07} className={i === 4 ? "col-span-2" : ""}><Pillar p={p} i={i} /></Reveal>
            ))}
          </div>
        </div>
      </div>
    </Wrap>
  </section>
);
